"use client";

import { useEffect } from "react";

interface JobApplyStep1DataLayerProps {
  job?: {
    title?: string;
  } | null;
}

const JobApplyStep1DataLayer = ({ job }: JobApplyStep1DataLayerProps) => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "ecommerce",
      eventCategory: "ecommerce",
      eventAction: "checkout",
      eventLabel: "step1",
    });

    if (!job?.title) {
      window.dataLayer.push({
        event: "checkout",
        ecommerce: {
          checkout: {
            actionField: { step: 1 },
            products: [
              {
                name: "Open",
                price: "10",
                brand: "Open",
                quantity: 1,
              },
            ],
          },
        },
      });
    }
  }, [job]); // If job changes, the effect will re-run

  return null; // Render nothing
};

export default JobApplyStep1DataLayer;
